/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerApiService } from './customer-api.service';

@Injectable({
  providedIn: 'root',
})
export class FeedbackApiService {
  constructor(private api: CustomerApiService) {}

  sendUserFeedback(title: string, message: string): Observable<any> {
    return this.api.post('/v1/support_requests/open', {
      subject: title,
      content: message,
    });
  }
}
